module.exports = __webpack_public_path__ + "static/media/newmotors.86996e7d.png";